import { OnlineTransportSession } from '../../types/transport';

const sessionsByGameId = new Map<string, OnlineTransportSession>();

export function registerOnlineTransportSession(gameId: string, session: OnlineTransportSession) {
  if (!gameId) return;
  sessionsByGameId.set(gameId, session);
}

export function unregisterOnlineTransportSession(gameId: string, session?: OnlineTransportSession) {
  if (!gameId) return;
  if (!session) {
    sessionsByGameId.delete(gameId);
    return;
  }
  const current = sessionsByGameId.get(gameId);
  if (current === session) {
    sessionsByGameId.delete(gameId);
  }
}

export function getOnlineTransportSession(gameId: string): OnlineTransportSession | null {
  if (!gameId) return null;
  return sessionsByGameId.get(gameId) || null;
}
